import { useTranslation } from "react-i18next";
import { Apartment } from "../../../../../types/apartments";
import { formatCurrency, getEquipmentName } from "../../../../../util";
import { i18n } from "../../../../../i18n/i18n";
import React from "react";
import { ServiceTypeSelectorOption } from "../../../../../types/order";
import useServiceStorage from "../../../../../hooks/useServiceStorage";
import { formatApartmentDetailsLine } from "./formatApartmentDetailsLine";

interface Props {
  data: Apartment;
  onSelectApartment: (apartment: Apartment) => void;
}

function ApartmentListCard({ data, onSelectApartment }: Props) {
  const { t } = useTranslation();
  const { featuredImage, name, price, langNames, accomodationdetail } = data;
  const { currentService } = useServiceStorage(
    "selectedService",
    ServiceTypeSelectorOption.APARTMENT
  );

  console.log("selectedServiceType", currentService);
  return (
    <div
      onClick={() => onSelectApartment(data)}
      className="flex border-[#3333331A] border-b mb-6 cursor-pointer pb-3"
    >
      <div className="rounded-lg">
        <img
          className="rounded-lg h-20 w-20 object-cover"
          src={featuredImage}
          alt=""
        />
      </div>
      <div className="flex flex-col ml-4">
        <p className="text-sm font-medium text-black">
          {getEquipmentName(name, langNames, "title")}
        </p>
        <div className="flex gap-2 text-sm text-gray-600 flex-wrap">
          {currentService !== ServiceTypeSelectorOption.VENUE ? (
            <span>{formatApartmentDetailsLine(accomodationdetail, t)}</span>
          ) : (
            <>
              {accomodationdetail?.kitchen > 0 && (
                <span>
                 • {accomodationdetail?.kitchen} {t("apartment.kitchen")}
                </span>
              )}

              {accomodationdetail?.terrace > 0 && (
                <span>
                  • {accomodationdetail?.terrace} {t("apartment.terrace")}
                </span>
              )}
              {accomodationdetail?.garden > 0 && (
                <span>
                  • {accomodationdetail?.garden} {t("apartment.garden")}
                </span>
              )}
              {accomodationdetail.terrace === 0 &&
                accomodationdetail.garden === 0 &&
                accomodationdetail.garden === 0 && (
                  <span>
                    • {accomodationdetail?.outdoor_space}{" "}
                    {t("apartment.no_outdoor_space")}
                  </span>
                )}
            </>
          )}
        </div>
        <div>
          {/* if price is not greater than 0 then show price on request */}
          {price <= 0 ? (
            <p className="text-black font-medium text-[16px]">
              {t("apartment.price_on_request")}
            </p>
          ) : (
            <p className="text-black font-medium text-[16px]">
              <span className="mr-1">{t("general.from")}</span>
              {formatCurrency(price, i18n.language)}
              &nbsp;/&nbsp;
              <span>{t("apartment.night")}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ApartmentListCard;
